module.exports = __webpack_public_path__ + "static/media/07.735523f6.mp3";